type BarChartHoverLabelProps = {
  /** Horizontal center of the bar. */
  x: number;
  /** Top edge of the bar (SVG y). */
  barTopY: number;
  text: string;
  /** Optional horizontal clamp so labels stay inside the chart. */
  minX?: number;
  maxX?: number;
  /** Minimum label y (keeps text inside top padding). */
  minY?: number;
  fontSize?: number;
};

/** Floating label above a bar on hover — matches the Ads tab chart style. */
export function BarChartHoverLabel({
  x,
  barTopY,
  text,
  minX,
  maxX,
  minY = 10,
  fontSize = 11,
}: BarChartHoverLabelProps) {
  const labelX =
    minX !== undefined && maxX !== undefined
      ? Math.min(Math.max(x, minX), maxX)
      : x;
  const labelY = Math.max(barTopY - 6, minY);

  return (
    <g pointerEvents='none'>
      <text
        x={labelX}
        y={labelY}
        textAnchor='middle'
        className='fill-gray-900 font-semibold tabular-nums'
        fontSize={fontSize}
        paintOrder='stroke'
        stroke='#ffffff'
        strokeWidth={3}
        strokeLinejoin='round'
      >
        {text}
      </text>
    </g>
  );
}
